<template>
  <multiple_form
    :forms="forms"
    :edit="props.isEdit"
    :editData="props.editData"
    :disabled="props.disabled"
    @submit="handelSubmit"
    submitText="审批"
    ref="formRef"
  >
    <template #approval>
      <h4>审批流程</h4>
      <approval_process_content :data="approvalProcessData">
      </approval_process_content>
    </template>
  </multiple_form>
</template>
<script setup>
  import { defineProps, defineEmits, computed, ref } from 'vue'
  import { message } from 'ant-design-vue'
  import { approval } from '@/api/person_application/person_application_approval'
  import { approvalProcess } from '@/api/person_application/person_application'
  import multiple_form from '@/components/multiple_form'
  import { resultOptions, gender, yesOrNot } from '@/utils/common'
  import { constantToOptions } from '@/utils/format'
  import approval_process_content from '@/components/approval_process_content'
  //初始化
  const props = defineProps({
    isEdit: Boolean,
    editData: Object,
    idField: String,
    isBatch: { default: false },
    disabled: { type: Boolean, default: false },
  })
  const emit = defineEmits(['submit'])

  const formRef = ref()
  //编辑、新增的表单
  const forms = computed(() => [
    {
      name: '来访人员信息',
      id: 'visitor',
      dataInObject: 'personApplication',
      hidden: props.isBatch,
      formItem: [
        {
          type: 'input',
          field: 'visitor_name',
          label: '姓名',
        },

        {
          type: 'radio',
          field: 'visitor_gender',
          options: constantToOptions(gender),
          label: '性别',
        },
        {
          type: 'input',
          field: 'visitor_nation',
          label: '民族',
        },
        // {
        //   type: 'input',
        //   field: 'visitor_education',
        //   label: '学历',
        // },
        {
          type: 'input',
          field: 'visitor_phone',
          label: '手机号码',
        },
        // {
        //   type: 'radio',
        //   field: 'veteran',
        //   options: constantToOptions(yesOrNot),
        //   label: '退役军人',
        // },
        {
          type: 'input',
          field: 'visitor_company',
          label: '申请人工作单位',
        },
        {
          type: 'input',
          field: 'visitor_address',
          label: '申请人现住址(详细)',
        },
        {
          type: 'radio',
          storeOptions: 'personVisitType',
          field: 'visitor_type',
          label: '访客类型',
        },
        {
          type: 'select',
          field: 'visitor_idcard_type',
          storeOptions: 'documentType',
          label: '证件类型',
        },
        {
          type: 'input',
          field: 'visitor_idcard',
          label: '证件号码',
        },
        {
          type: 'image',
          field: 'visitor_face_photo',
          label: '来访人员人像图片',
        },
        {
          type: 'image',
          field: 'visitor_idcard_photo1',
          label: '证件人像面图片(原件)',
        },
        {
          type: 'image',
          field: 'visitor_idcard_photo2',
          label: '证件国徽面图片(原件)',
        },
      ],
    },
    {
      name: '来访信息',
      id: 'visit',
      dataInObject: 'personApplication',
      hidden: props.isBatch,
      formItem: [
        {
          type: 'input',
          field: 'visit_content',
          label: '访问事由',
        },
        {
          type: 'dateRange',
          startField: 'visit_begin_time',
          endField: 'visit_end_time',
          label: '来访/截止时间',
        },
        {
          type: 'select',
          field: 'visit_area',
          label: '申请园区',
          storeOptions: 'areaType',
        },
      ],
    },
    {
      name: '被访信息',
      id: 'interviewee',
      dataInObject: 'personApplication',
      hidden: props.isBatch,
      formItem: [
        {
          type: 'input',
          field: 'interviewee_name',
          label: '被访问人',
        },
        {
          type: 'input',
          field: 'interviewee_phone',
          label: '被访问人电话',
        },
        {
          type: 'select',
          field: 'interviewee_depart_id',
          storeOptions: 'dept',
          label: '被访问单位',
        },
      ],
    },
    {
      name: '审批信息',
      id: 'approval',
      formItem: [
        {
          type: 'radio',
          field: 'result',
          label: '审批结果',
          defaultValue: 1,
          options: constantToOptions(resultOptions),
          disabled: false,
          onChange: (val) => {
            if (
              formRef.value &&
              formRef.value.formRefs &&
              formRef.value.formRefs.approval &&
              formRef.value.formRefs.approval.formState
            ) {
              formRef.value.formRefs.approval.formState.remark =
                val.target.value === '1' ? '审批通过。' : '审批不通过。'
            }
          },
        },
        {
          type: 'textarea',
          field: 'remark',
          label: '审批意见',
          width: '300px',
          defaultValue: '审批通过。',
          disabled: false,
        },
      ],
    },
  ])

  async function handelSubmit(data) {
    const messageText = '审核'
    const res = await approval({
      ...data,
      taskIds: props.editData[props.idField],
    })
    if (res.success) {
      message.success(messageText + '成功！')
      emit('submit')
    } else {
      message.warn(messageText + '错误：', res.message)
    }
  }

  const approvalProcessData = ref()
  if (props.editData?.personApplication?.person_application_id) {
    getApprovalProcess()
  }
  async function getApprovalProcess() {
    const res = await approvalProcess({ id: props.editData.personApplication.person_application_id })
    approvalProcessData.value = res.data
  }
</script>
